import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="container-edge py-32 text-center" data-testid="not-found">
      <div className="overline text-terracotta">404</div>
      <h1 className="editorial-h1 mt-4">This route doesn't exist on our network.</h1>
      <p className="mt-6 text-muted2">The page you are looking for has either taken off or been redirected.</p>
      <Link to="/" className="btn-primary mt-10" data-testid="back-home">
        <ArrowLeft className="w-4 h-4" /> Back to home
      </Link>
    </div>
  );
}
